module.exports = __webpack_public_path__ + "static/img/mask.9a3ce99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download/mask.png
// module id = Yw35
// module chunks = 3